module.exports = __webpack_public_path__ + "img/1.7ae9d888.jpg";